import React from 'react';
import { useAuth } from 'react-oidc-context';
import LoginPage from './components/LoginPage';
import ChatInterface from './components/ChatInterface';
import AuthInitializer from './components/AuthInitializer';
import { useTenantStore } from './stores/useTenantStore';
import './App.css';

function App() {
  const auth = useAuth();
  const { isConfigured } = useTenantStore();

  return (
    <AuthInitializer>
      <div className="App">
        {auth.isAuthenticated ? (
          isConfigured ? <ChatInterface /> : <LoginPage />
        ) : (
          <LoginPage />
        )}
      </div>
    </AuthInitializer>
  );
}

export default App;
